import { render } from "./TicketSvg.vue?vue&type=template&id=bcc79344&ts=true"
import script from "./TicketSvg.vue?vue&type=script&lang=ts"
export * from "./TicketSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__